import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-4 md:py-8 text-center" data-id="element-0">
    <p className="text-lg md:text-2xl font-display italic text-brand-violetDark/85 leading-relaxed font-[800]" data-id="element-1">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-violetDark bg-brand-surface" data-id="element-2">
      <UrgencyBanner data-id="element-3" />
      <Hero data-id="element-4" />
      <PainPoints data-id="element-5" />
      <MethodOverview data-id="element-6" />
      <MaterialPreview data-id="element-7" />
      <MoreTestimonials data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <CostComparison data-id="element-11" />
      <TransitionPhrase data-id="element-12" />
      <EmotionalClose data-id="element-13" />
      <Footer data-id="element-14" />
      <FloatingNotification data-id="element-15" />
    </div>;
}